import { jsx as _jsx } from "react/jsx-runtime";
const variants = {
    primary: {
        background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
        color: "#fff",
        border: "none",
        boxShadow: "0 2px 8px rgba(99,102,241,0.35)",
    },
    secondary: {
        background: "rgba(255,255,255,0.06)",
        color: "#f8fafc",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "none",
    },
    ghost: {
        background: "transparent",
        color: "#64748b",
        border: "1px solid transparent",
    },
    danger: {
        background: "rgba(244,63,94,0.16)",
        color: "#fda4af",
        border: "1px solid rgba(244,63,94,0.28)",
    },
};
const sizes = {
    sm: { padding: "6px 14px", fontSize: 12, borderRadius: 8 },
    md: { padding: "10px 20px", fontSize: 14, borderRadius: 10 },
    lg: { padding: "14px 28px", fontSize: 16, borderRadius: 12 },
};
export function Button({ variant = "primary", size = "md", loading, children, style, disabled, ...rest }) {
    return (_jsx("button", { style: {
            ...variants[variant],
            ...sizes[size],
            fontWeight: 600,
            cursor: disabled || loading ? "not-allowed" : "pointer",
            opacity: disabled || loading ? 0.6 : 1,
            transition: "all 0.15s ease",
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            letterSpacing: "0.01em",
            ...style,
        }, disabled: disabled || loading, ...rest, children: loading ? _jsx("span", { style: { opacity: 0.7 }, children: "Loading\u2026" }) : children }));
}
